// SPDX-License-Identifier: MIT
import { Entropy } from './entropy';
export const BIP39_ENTROPY_STRENGTHS = {
    ONE_HUNDRED_TWENTY_EIGHT: 128,
    ONE_HUNDRED_SIXTY: 160,
    ONE_HUNDRED_NINETY_TWO: 192,
    TWO_HUNDRED_TWENTY_FOUR: 224,
    TWO_HUNDRED_FIFTY_SIX: 256
};
export class BIP39Entropy extends Entropy {
    static strengths = [
        BIP39_ENTROPY_STRENGTHS.ONE_HUNDRED_TWENTY_EIGHT,
        BIP39_ENTROPY_STRENGTHS.ONE_HUNDRED_SIXTY,
        BIP39_ENTROPY_STRENGTHS.ONE_HUNDRED_NINETY_TWO,
        BIP39_ENTROPY_STRENGTHS.TWO_HUNDRED_TWENTY_FOUR,
        BIP39_ENTROPY_STRENGTHS.TWO_HUNDRED_FIFTY_SIX
    ];
    static getName() {
        return 'BIP39';
    }
}
//# sourceMappingURL=bip39.js.map